import { apiClient, __isNil } from '../../utils';
import { handleError } from '../handleError';
import { uploadMedia } from '../';

export const editBlogPost = async ({
  bi,
  siteId,
  title,
  tags,
  content,
  si,
  st,
  siteAuthor,
  coverImage,
}) => {
  try {
    // Upload blog post's cover image
    if (coverImage instanceof File) {
      const imagePayload = {
        ft: 18,
        fi: bi,
        ma: coverImage,
        mc: title,
      };
      await uploadMedia(imagePayload);
    }

    const payload = {
      bi,
      site: siteId,
      ...(!__isNil(title) ? { title } : {}),
      ...(!__isNil(si) ? { si } : {}),
      ...(!__isNil(tags) ? { tags } : {}),
      ...(!__isNil(content) ? { content } : {}),
      ...(!__isNil(st) ? { st } : {}),
      ...(!__isNil(siteAuthor) ? { siteAuthor } : {}),
    };
    const rsp = await apiClient.post('/merchant/blog/edit', { data: payload });
    return rsp;
  } catch (e) {
    handleError(e);
    throw e;
  }
};
